import { render, staticRenderFns } from "./DayTotalHours.vue?vue&type=template&id=0af5da20&"
import script from "./DayTotalHours.vue?vue&type=script&lang=ts&"
export * from "./DayTotalHours.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports